<template>
  <div>
    <!-- Map box -->
    <div class="grid-x">
      <div v-if="ad.flats && ad.flats.length > 1" class="cell small-12 mapcontainer" :class="{hasMap:showMap}">
        <LMap
          v-if="showMap"
          ref="flatmap"
          class="ad-map"
          :zoom.sync="zoom"
          :options="mapOptions"
          :bounds="bounds"
          :min-zoom="minZoom"
          :max-zoom="maxZoom">
          <OpenFreeMapLayer />
          <!-- <LMarker :lat-lng="center" :icon="icon" /> -->
          <template v-for="(flat, index) in ad.flats">
            <LMarker v-if="index == currentFlat" :key="flat.id" :lat-lng="{lat: flat.lat, lng: flat.lng}" :icon="icon" @click="showflat(index)" />
            <LMarker v-else :key="flat.id" :lat-lng="{lat: flat.lat, lng: flat.lng}" :icon="iconInactive" @click="showflat(index)" />
          </template>
        </LMap>
      </div>

      <div v-else-if="ad.flats && ad.flats.length > 0" class="cell small-12 mapcontainer" :class="{hasMap:showMap}">
        <LMap
          v-if="showMap"
          ref="flatmap"
          class="ad-map"
          :zoom.sync="zoom"
          :options="mapOptions"
          :center="{
            lat: ad.flats[0].lat,
            lng: ad.flats[0].lng
          }"
          :min-zoom="minZoom"
          :max-zoom="maxZoom">
          <OpenFreeMapLayer />
          <!-- <LMarker :lat-lng="center" :icon="icon" /> -->
          <template v-for="(flat, index) in ad.flats">
            <LMarker v-if="index == currentFlat" :key="flat.id" :lat-lng="{lat: flat.lat, lng: flat.lng}" :icon="icon" @click="showflat(index)" />
            <LMarker v-else :key="flat.id" :lat-lng="{lat: flat.lat, lng: flat.lng}" :icon="iconInactive" @click="showflat(index)" />
          </template>
        </LMap>
      </div>
    </div>
  </div>
</template>

<script>

// import { latLngBounds, latLng } from 'leaflet'
import { latLngBounds } from 'leaflet'
import { LMap, LMarker } from 'vue2-leaflet'
import OpenFreeMapLayer from '@/components/OpenFreeMapLayer.vue'

export default {

  components: { LMap, LMarker, OpenFreeMapLayer },
  props: {
    currentFlat: {
      type: Number,
      required: true
    },
    ad: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // center: { lat: 51.505, lng: -0.09 },
      opacity: 0.6,
      token: 'your token if using mapbox',
      mapOptions: {
        zoomControl: true,
        attributionControl: true,
        zoomSnap: true,
        scrollWheelZoom: false,
        dragging: !window.L.Browser.mobile,
        tap: false,
        noBlockingAnimations: true
      },
      zoom: 13,
      minZoom: 1,
      maxZoom: 20,
      zoomPosition: 'topleft',
      attributionPosition: 'bottomright',
      layersPosition: 'topright',
      attributionPrefix: 'Vue2Leaflet',
      imperial: false,
      Positions: ['topleft', 'topright', 'bottomleft', 'bottomright'],

      icon: window.L.icon({
        iconUrl: '/img/marker.svg',
        iconSize: [35, 44],
        iconAnchor: [17.5, 44]
      }),

      iconInactive: window.L.icon({
        iconUrl: '/img/marker-disabled.svg',
        iconSize: [35, 44],
        iconAnchor: [17.5, 44],
        // opacity: 0.5
      }),
    }
  },

  computed: {

    showMap() {
      if (this.ad.flats[0] && this.ad.flats[1]) {
        return this.ad.flats[0].lat != null || this.ad.flats[1].lat != null
      }
      if (this.ad.flats[0]) {
        return this.ad.flats[0].lat != null
      }
      return false
    },
   
    bounds() {
      if (!this.ad.flats || !this.ad.flats.length) return null
      return latLngBounds(this.ad.flats.map(flat => ([ flat.lat, flat.lng ]))).pad(0.2)

      // return new L.LatLngBounds({ lat: 51.505, lng: -0.09 })
      // return this.ad.flats.map(flat => ([ flat.lat, flat.lng ]))
    }
  },
  watch: {
    currentFlat: {
      handler(val) {
        // if (val) {
        //   this.getZip(val)
        // }
        // console.log(val)

        this.$refs.flatmap.setCenter({
          lat: this.ad.flats[val].lat,
          lng: this.ad.flats[val].lng
        })
      }
    }
  },
  // created() {
  //   const L = window.L
  // },

  // watch: {

  //      currentFlat: {
  //         handler(old,new) {

  //         // this.$refs.flatmap.setCenter({
  //         //   lat: this.ad.flats[i].lat,
  //         //   lng: this.$store.getters.currentAd.lng
  //         // })
  //         console.log(old,new)
  //       }
  //     }
  // },

  methods: {

    // moveMap(id) {
    //   this.$refs.flatmap.setCenter({
    //     lat: this.ad.flats[i].lat,
    //     lng: this.$store.getters.currentAd.lng
    //   })
    // },

    showflat(i) {
      // alert(i)
      this.$emit('toggleflat', i)
    }
  }

}
</script>

<style scoped>

.mapcontainer{
  /* background-color:red; */
  margin-bottom:10px;
}

.hasMap{
  min-height:300px;
}
</style>
